import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import GLOCOSE_COLUMNS from 'constants/GLOCOSE_COLUMNS';
import DAY_ZONE_TYPES from 'constants/DAY_ZONE_TYPES';
import TIRBar from './TIRBar';
import VBox from 'components/common/VBox';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';
import React from 'react';
import html2canvas from "html2canvas";
import useSetChartData from 'hooks/app/useSetChartData';

export default function GlocoseTIRChart(props) {
  const {
    duration,
    hash,
    data,
    ...rest
  } = props;

  const ref = React.useRef();
  const table = React.useMemo(() => (
    <table {...{ ref }}>
      <tbody>
        <tr>
          <td>
            <VBox between vstart>
              <div>
                {T('TAR')}
              </div>
              <div>
                {T('TIR')}
              </div>
              <div>
                {T('TBR')}
              </div>
            </VBox>
          </td>
          {GLOCOSE_COLUMNS.map((name, index) => (
            <td key={index}>
              <TIRBar
                {...hash[name]}
              />
            </td>
          ))}
        </tr>
      </tbody>
      {/* <tfoot>
        <tr>
          <th>
            <div>
            </div>
          </th>
          {GLOCOSE_COLUMNS.map((name, index) => {
            return (
              <th key={index}>
                <div>
                  {name}
                </div>
              </th>
            );
          })}
        </tr>
      </tfoot> */}
    </table>
  ), [hash]);

  const setChartData = useSetChartData('GlocoseTIRChart');
  const completeTimeoutIdRef = React.useRef();
  React.useEffect(() => {
    if (data.uninitialized) return;
    if (duration) return;
    if (!ref.current) return;
    clearTimeout(completeTimeoutIdRef.current);
    completeTimeoutIdRef.current = setTimeout(() => {
      clearTimeout(completeTimeoutIdRef.current);
      const run = async () => {
        if (!ref.current) return;
        const {
          width,
          height,
        } = ref.current.getBoundingClientRect();
        if (!width) return;
        if (!height) return;
        const canvas = await html2canvas(ref.current, {
          scale: 2,
          logging: false,
        });
        const url = canvas.toDataURL('image/png');
        setChartData((data) => data.uninitialized ? ({ url, width, height }) : data);
        URL.revokeObjectURL(url);
        canvas.remove();
      };
      run();
    }, 6000);
  }, [data.uninitialized, duration, setChartData, table]);

  return (
    <div {...ex('GlocoseTIRChart', rest)}>
      {table}
    </div>
  );
}

